import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="popup"
export default class extends Controller {
  connect() {
  }

  show() {
    document.querySelector('.popup').classList.add('show');
  }

  toggle() {
    document.querySelector('.popup').classList.toggle('show');
  }

  toggleButton () {
    document.querySelector('a.accept').classList.toggle('opacity-40');
  }

  validate(event) {
    if (!document.querySelector('input[type="checkbox"]:checked')) {
      event.preventDefault();
    }
  }
}
